
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soc2-compliance",
      function () {
        return require("private-next-pages/soc2-compliance.tsx");
      }
    ]);
  